import React from 'react';
import { Award, FileCheck } from 'lucide-react';
import CTECertificate from './licenses/EaseCarry_CTE.pdf';
import CTOCertificate from './licenses/EaseCarry_CTO.pdf';

const Licenses = () => {
  const licenses = [
    {
      id: 1,
      name: 'CTE Certified',
      description: 'Certified for environmental compliance and sustainability standards',
      icon: Award,
      pdfUrl: CTECertificate,
      color: 'from-emerald-500 to-teal-600'
    },
    {
      id: 2,
      name: 'CTO Certified',
      description: 'Technical certification for product quality and safety',
      icon: FileCheck,
      pdfUrl: CTOCertificate,
      color: 'from-green-500 to-emerald-600'
    }
  ];

  const handleLicenseClick = (pdfUrl, name) => {
    window.open(pdfUrl, '_blank');
  };

  return (
    <section id="licenses" className="py-24 bg-[hsl(var(--pure-white))]">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl lg:text-5xl text-[hsl(var(--charcoal))] mb-4">
            Our <span className="text-[hsl(var(--earth-green))] italic">Licenses</span>
          </h2>
          <p className="font-body text-lg text-[hsl(var(--stone-gray))] max-w-2xl mx-auto">
            Certified and trusted for quality, safety, and environmental standards
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {licenses.map((license) => {
            const Icon = license.icon;
            return (
              <div
                key={license.id}
                onClick={() => handleLicenseClick(license.pdfUrl, license.name)}
                className="group relative bg-[hsl(var(--cream))] rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
              >
                {/* Gradient background on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${license.color} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-300`}></div>
                
                {/* Content */}
                <div className="relative z-10">
                  <div className={`w-20 h-20 bg-gradient-to-br ${license.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                  
                  <h3 className="font-heading text-3xl text-[hsl(var(--charcoal))] mb-3 group-hover:text-[hsl(var(--earth-green))] transition-colors">
                    {license.name}
                  </h3>
                  
                  <p className="font-body text-[hsl(var(--stone-gray))] leading-relaxed mb-4">
                    {license.description}
                  </p>
                  
                  <div className="flex items-center gap-2 text-[hsl(var(--earth-green))] font-accent font-semibold uppercase tracking-wider text-sm group-hover:gap-4 transition-all">
                    <span>View Certificate</span>
                    <svg 
                      className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>

                {/* Corner accent */}
                <div className="absolute top-6 right-6 w-12 h-12 border-t-2 border-r-2 border-[hsl(var(--earth-green))]/20 group-hover:border-[hsl(var(--earth-green))] transition-colors rounded-tr-2xl"></div>
              </div>
            );
          })}
        </div>

        {/* Trust badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-[hsl(var(--leaf-light))]/50 px-6 py-3 rounded-full">
            <Award className="w-5 h-5 text-[hsl(var(--earth-green))]" />
            <span className="font-body text-sm text-[hsl(var(--stone-gray))]">
              Independently certified and verified
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Licenses;
